export function autoHeightAnimate(element, time) {
  var curHeight = element.height();
  var autoHeight = element.css('height', 'auto').height();
  element.height(curHeight);
  element.stop().animate({
    height: autoHeight
  }, time);
}